import {
  UserOutlined,
  IdcardOutlined,
  ContactsOutlined,
  CloudServerOutlined,
  CarryOutOutlined,
  DashboardOutlined,
  ReadFilled,
  ControlOutlined,
  ProjectOutlined,
  ClusterOutlined,
} from "@ant-design/icons";
import { FiPower } from "react-icons/fi";

import { Button, Layout, Menu } from "antd";
import React, { useState, useCallback, Suspense, useMemo } from "react";

import { Spin } from "antd";
import { Link, useRouteMatch, Switch, Route, Redirect } from "react-router-dom";
import { useAuth } from "../../hooks/auth";
import logo from "../../assets/logoTextWhite.png";
import UserAvatar from "../../components/UserAvatar";
import Users from "../Users";
import "./styles.css";
import { LogoContainer, Profile, RightSideHeader } from "./styles";
import Customers from "../Customers";
import Projects from "../Projects";
import Project from "../Project";
import Activities from "../Activities";
import Dashboards from "../Dashboards";
import Forbidden from "../Forbidden";
import Notifications from "../Notifications";
import UserRoles from "../../enums/UserRoles";
import Allocations from "../Allocations";
import User from "../User";
import Equipments from "../Equipments";
import Opex from "../Opex";
import FactoryActivityPage from "../FactoryActivity";
import Contractors from "../Contractors";
import Kanban from "../Kanban";
import KanbanProject from "../Kanban/Project";
import KanbanRole from "../Kanban/Project/Role";
import ProjectInternal from "../ProjectsInternal";

interface IForbiddenRoute {
  onlyAdmin?: boolean;
  onlyManager?: boolean;
  onlyTechnical?: boolean;
  key: string;
  onlyDev?: boolean;
}

const { Header, Content, Sider } = Layout;

const App: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);

  const { user, signOut } = useAuth();

  const users = useRouteMatch("/app/users");
  const userDetail = useRouteMatch("/app/users/:user_id");
  const customers = useRouteMatch("/app/customers");
  const projects = useRouteMatch("/app/projects");
  const projectDetails = useRouteMatch("/app/projects/:project_id");
  const activities = useRouteMatch("/app/activities");
  const allocations = useRouteMatch("/app/allocations");
  const dashboards = useRouteMatch("/app");
  const initial = useRouteMatch("/");
  const equipments = useRouteMatch("/app/equipments");
  const opex = useRouteMatch("/app/opex");
  const factoryActivity = useRouteMatch("/app/factory");
  const contractors = useRouteMatch("/app/contractors");
  const kanban = useRouteMatch("/app/kanban");
  const kanbanId = useRouteMatch("/app/kanban/projects/:projectId");
  const kanbanProject = useRouteMatch("/app/kanban/projects");
  const KanbanAdm = useRouteMatch("/app/kanban/administrative");
  const KanbanDev = useRouteMatch("/app/kanban/development");
  const ProjectsInternal = useRouteMatch("/app/projects/internal");

  const isManager = useMemo(() => user.role === UserRoles.Manager, [user.role]);

  const isManagerOrAdmin = useMemo(
    () =>
      user.role === UserRoles.Manager || user.role === UserRoles.Administrative,
    [user.role],
  );

  const isTechnical = useMemo(() => user.role === UserRoles.Technician, [
    user.role,
  ]);

  const isDeveloper = useMemo(() => user.role === UserRoles.Developer, [
    user.role,
  ]);

  const Avatar = useCallback(
    () => <UserAvatar name={user.name} url={user.avatar_url} size={48} />,

    [user.avatar_url, user.name],
  );
  const routes = [
    {
      path: "/app",
      component: <Dashboards />,
      onlyManager: true,
      exact: true,
      icon: <DashboardOutlined />,
      title: "Dashboards",
      key: "dashboards",
    },
    {
      path: "/app/users",
      component: <Users />,
      onlyAdmin: true,
      exact: true,
      icon: <UserOutlined />,
      title: "Usuários",
      key: "users",
    },
    {
      path: "/app/equipments",
      component: <Equipments />,
      onlyAdmin: true,
      exact: true,
      icon: <ReadFilled />,
      title: "Equipamentos",
      key: "equipments",
      onlyTechnical: true,
    },
    {
      path: "/app/opex",
      component: <Opex />,
      onlyAdmin: true,
      exact: true,
      icon: <ControlOutlined />,
      title: "Opex",
      key: "opex",
    },
    {
      path: "/app/users/:userId",
      component: <User />,
      onlyAdmin: false,
      exact: false,
      hidden: true,
      key: "users",
    },
    {
      path: "/app/customers",
      component: <Customers />,
      onlyAdmin: true,
      exact: false,
      icon: <IdcardOutlined />,
      title: "Clientes",
      key: "customers",
    },
    {
      path: "/app/contractors",
      component: <Contractors />,
      onlyAdmin: true,
      exact: false,
      icon: <ContactsOutlined />,
      title: "Contratantes",
      key: "contractors",
    },
    {
      path: "/app/projects",
      component: <Projects />,
      onlyAdmin: true,
      exact: true,
      icon: <CloudServerOutlined />,
      title: "Projetos",
      key: "projects",
    },
    {
      path: "/app/projects/internal",
      component: <ProjectInternal />,
      onlyDev: true,
      hidden: !isDeveloper,
      exact: true,
      icon: <CloudServerOutlined />,
      title: "Projetos",
      key: "projects",
    },
    {
      path: "/app/factory",
      component: <FactoryActivityPage />,
      onlyAdmin: true,
      exact: true,
      icon: <ProjectOutlined />,
      title: "Atividades Fábrica",
      key: "activities_factory",
    },
    {
      path: "/app/projects/:projectId",
      component: <Project />,
      onlyAdmin: false,
      exact: false,
      hidden: true,
      key: "projects",
    },
    {
      path: "/app/activities",
      component: <Activities />,
      onlyAdmin: false,
      exact: false,
      icon: <CarryOutOutlined />,
      title: "Minhas atividades",
      key: "activities",
      onlyDev: true,
    },
    {
      path: "/app/kanban/administrative",
      component: <KanbanRole />,
      onlyAdmin: true,
      exact: true,
      key: "kanban_project",
      hidden: true,
    },
    {
      path: "/app/kanban/development",
      component: <KanbanRole />,
      onlyAdmin: true,
      exact: true,
      key: "kanban_project",
      hidden: true,
    },
    {
      path: "/app/kanban/projects",
      component: <KanbanProject />,
      onlyAdmin: false,
      exact: true,
      icon: <ClusterOutlined />,
      title: "Kanban Geral",
      key: "kanban_project",
    },
    {
      path: "/app/kanban",
      component: <Kanban />,
      onlyAdmin: false,
      exact: true,
      icon: <ClusterOutlined />,
      title: "Kanban Atividades",
      key: "kanban",
      onlyDev: true,
    },
    {
      path: "/app/kanban/projects/:projectId",
      component: <Kanban />,
      onlyAdmin: false,
      exact: true,
      hidden: true,
      key: "kanban_project",
    },
    {
      path: "/app/allocations",
      component: <Allocations />,
      onlyAdmin: true,
      exact: false,
      icon: <CarryOutOutlined />,
      title: "Alocações",
      key: "allocations",
    },
  ];

  const handleGetSelectedMenu = useCallback(() => {
    if (kanbanProject || kanbanId || KanbanAdm || KanbanDev) {
      return "kanban_project";
    }
    if (kanban) {
      return "kanban";
    }
    if (contractors) {
      return "contractors";
    }
    if (factoryActivity) {
      return "activities_factory";
    }
    if (users || userDetail) {
      return "users";
    }
    if (opex) {
      return "opex";
    }
    if (equipments) {
      return "equipments";
    }
    if (customers) {
      return "customers";
    }
    if (projects || projectDetails || ProjectsInternal) {
      return "projects";
    }
    if (activities) {
      return "activities";
    }
    if (allocations) {
      return "allocations";
    }
    if (dashboards || initial) {
      return "dashboards";
    }
    return "";
  }, [
    KanbanDev,
    kanbanProject,
    kanbanId,
    kanban,
    contractors,
    factoryActivity,
    users,
    userDetail,
    opex,
    equipments,
    customers,
    projects,
    projectDetails,
    activities,
    allocations,
    dashboards,
    initial,
    ProjectsInternal,
  ]);

  const forbiddenRoute = ({
    onlyTechnical,
    onlyAdmin,
    onlyManager,
    key,
  }: IForbiddenRoute): boolean => {
    if (isTechnical && key !== "equipments") return true;
    return Boolean(
      onlyTechnical &&
        !isTechnical &&
        ((onlyManager && !isManager) || (!!onlyAdmin && !isManagerOrAdmin)),
    );
  };

  const validatedRoute = ({
    onlyAdmin,
    onlyManager,
    onlyDev,
    onlyTechnical,
  }: IForbiddenRoute): boolean => {
    if (onlyDev && isTechnical) return false;
    if (onlyTechnical && isTechnical) return true;
    if (onlyDev && isDeveloper) return true;
    if (onlyAdmin && isManagerOrAdmin) return true;
    if (isManagerOrAdmin) return true;
    return !onlyAdmin && !onlyManager;
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={value => setCollapsed(value)}
        width="270"
        className="sider hide-on-mobile"
      >
        <LogoContainer>
          <img src={logo} alt="eTI" />
        </LogoContainer>
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[handleGetSelectedMenu()]}
          style={{
            overflowY: "auto",
            height: "calc(100% + 48px)",
          }}
          items={routes
            .filter(route => validatedRoute(route))
            .filter(route => !route.hidden)
            .map(route => ({
              key: route.key,
              label: (
                <Link to={route.path}>
                  {route.icon}
                  <span>{route.title}</span>
                </Link>
              ),
            }))}
        />
      </Sider>
      <Layout className="site-layout">
        <Header>
          <Profile>
            <Avatar />
            <div>
              <span>Bem-vindo,</span>
              <Link to={isTechnical ? "/app/equipments" : `/profile`}>
                <strong>{user.name}</strong>
              </Link>
            </div>
          </Profile>

          <RightSideHeader>
            <Suspense fallback={<Spin />}>
              <Notifications />
            </Suspense>
            <Button type="link" icon={<FiPower />} onClick={signOut} />
          </RightSideHeader>
        </Header>
        <Content style={{ margin: "24px 24px" }}>
          <Suspense fallback={<Spin />}>
            <Switch>
              {routes.map(route => {
                return (
                  <Route key={route.key} exact={route.exact} path={route.path}>
                    {forbiddenRoute(route) ? (
                      <Redirect to="/app/forbidden" />
                    ) : (
                      route.component
                    )}
                  </Route>
                );
              })}
              <Route exact path="/app/forbidden">
                <Forbidden />
              </Route>
            </Switch>
          </Suspense>
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
